/* global google */

import { srcCorregimientos,  center } from './../../constants/services/map'

var polyCroquis

export function initMap(id, mapVar, mapData, session) {
  setTimeout(() => {
    try {
      startMap(id, mapVar, mapData, session);
    } catch (error) { }
  }, 700);
}
function startMap(id, mapVar, mapData, session) {
  mapVar = new google.maps.Map(document.getElementById(id), {
    center,
    zoom: 12,
    disableDefaultUI: true,
    styles: styleClean
  });
  HttpServiceCom(srcCorregimientos, mapVar, session);
  createHeat(mapData, mapVar);
}

function HttpServiceCom(src, map, session = { user: { users: { perfil: 'ASOMURA' } } }) {
  var xhttpIcon = new XMLHttpRequest();
  xhttpIcon.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        // DeletePolysInMap(capaActual);
        var xmlString = this.response;
        var parser = new DOMParser();
        var comunas = parser.parseFromString(xmlString, "text/xml")
        var dataPolys = CreateDataForPolygon(comunas, false)
        polyCroquis = CreatePolygonLayer(dataPolys, { zIndex: 1, color: 'rgb(0,183,255)', fillOpacity: 0 });    //amarillo
        SetPolysInMap(polyCroquis, map);
        // setTimeout(() => {
        //   fitAllMap(map)
        // }, 1000)

        // if(session.user.users.perfil === 'ASOMURA'){
        //     SetPolysInMap(polyCroquis, map);
        //     setTimeout(() => {
        //         fitAllMap(map)
        //     }, 1000)
        // } else {
        //     let id
        //     switch(session.user.users.perfil){
        //         case 'Arboletes': id = 0; break
        //         case 'San Juan de Urabá': id = 1; break
        //         case 'Necoclí': id = 2; break
        //         case 'San Pedro de Urabá': id = 3; break
        //         case 'Turbo': id = 4; break
        //         case 'Apartadó': id = 5; break
        //         case 'Carepa': id = 6; break
        //         case 'Chigorodó': id = 7; break
        //         case 'Murindó': id = 8; break
        //         case 'Mutatá': id = 9; break
        //         default:  break
        //     }
        //     polyCroquis[id].setMap(map)
        //     setTimeout(() => {
        //         let bounds = new google.maps.LatLngBounds();
        //         bounds = getBounds(polyCroquis[id], bounds)
        //         map.fitBounds(bounds);                    
        //     }, 1000)
        // }                
      }
      else {
        console.error(this.responseText);
      }
    }
  };
  xhttpIcon.open("GET", src, true);
  xhttpIcon.send();
}

function CreateDataForPolygon(doc, isCroquis = true) {
  let polygons = [];
  var places = doc.getElementsByTagName('Placemark');
  for (let i = 0; i < places.length; i++) {
    var coords = places[i].getElementsByTagName('coordinates');
    for (let j = 0; j < coords.length; j++) {
      polygons.push({
        polygon: GetCordsFromPlacemark(coords[j]),
        description: isCroquis ? 'shape' : GetDescFromPlacemark(places[i])
      })
    }
  }
  return polygons;
}

function SetPolysInMap(polygon, map) {
  for (let i = 0; i < polygon.length; i++) {
    polygon[i].setMap(map)
  }
}


// function getBounds(poly, bounds) {
//   var latLngs = poly.getPath()
//   for (var i = 0; i < latLngs.length; i++) {
//     bounds.extend(latLngs.getAt(i));
//   }
//   return bounds
// }

function GetDescFromPlacemark(place) {
  var desc = place.getElementsByTagName('SchemaData')[0].getElementsByTagName('SimpleData');
  var resp = {};
  for (let i = 0; i < desc.length; i++) {
    resp = {
      ...resp,
      [desc[i].getAttribute('name')]: desc[i].innerHTML
    }
  }
  return resp;
}
function GetCordsFromPlacemark(coords) {
  var coordsVec = coords.innerHTML.split(" ");
  var resp = [];
  for (let i = 0; i < coordsVec.length; i++) {
    let vec = coordsVec[i].split(',');
    if (!isNaN(Number(vec[1])))
      resp.push({ lng: Number(vec[0]), lat: Number(vec[1]) });
  }
  // let tales = CreatePolygonMap(resp, color, fillOpacity, description, zIndex)
  return resp
}

function createHeat(vector, map) {
  let data = vector.map((value, i) => {
    return new google.maps.LatLng(value)
  });
  let intensity = (vector.length * 0.15);
  new google.maps.visualization.HeatmapLayer({
    data: data,
    maxIntensity: intensity,
    map
  });
}

function CreatePolygonLayer(data, options = { zIndex: 1, color: '#fff', fillOpacity: '0' }) {
  var polygonsLayer = data.filter(item => {
    return true
  }).map(item => {
    return CreatePolygonMap(item.polygon, item.description, options)
  })
  return polygonsLayer
}

function CreatePolygonMap(coords, description, options) {
  var poly = new google.maps.Polygon({
    paths: coords,
    strokeColor: options.color,
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: options.color,
    fillOpacity: options.fillOpacity,
    zIndex: options.zIndex,
    desc: description
  });
  return poly;
}

// function fitAllMap(map) {
//   let bounds = new google.maps.LatLngBounds();
//   for (let i = 0; i < polyCroquis.length; i++) {
//     if (polyCroquis[i].desc.NOMBRE_VER.includes('COMUNA')) {
//       bounds = getBounds(polyCroquis[i], bounds)
//     }
//   }
//   map.fitBounds(bounds);
// }

var styleClean = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "administrative.neighborhood",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "white-color"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];